import environmentSettings from './environments';

/** To test on mobile, see docs/testing-on-a-real-mobile-device.md */
const _MOBILE_TESTING_BASE_API_ORIGIN = 'http://192.168.0.106:8000';
const BASE_API_ORIGIN = 'http://localhost:8000';

/**
 * Base settings
 *
 * When adding new settings on a per-env basis, ensure that they're added here
 * first to ensure type safety and assist IDE integration.
 */
export const baseSettings = {
  ENVIRONMENT: import.meta.env?.MODE ?? 'test',

  APP_NAME: 'Evolve AI App Studio',
  TENANT_NAME: 'BurnsRED',

  BASE_API_ORIGIN,

  // axiosInstance provides this as baseURL
  BASE_API_URL: `${BASE_API_ORIGIN}/api`,

  // these URLs are NOT based on BASE_API_URL, so are composed after merging
  // environmentSettings; they are stubbed here for the sake of TS
  AUTH_PATHNAME: '/auth/', // composed below
  AUTH_URL: '', // composed below
  SSO_URL: '', // composed below
  FILE_UPLOAD_URL: '', // composed below
  IMAGE_UPLOAD_URL: '',
  MOCK_API_URL: '',
  ADMIN_URL: '',

  // these URLs are composed with axios.config.baseURL == BASE_API_URL
  SCAN_FILE_URI: '/scan_file/',

  CSRF_COOKIE_NAME: 'appstorecsrftoken',

  APPLICATION_HOST_SUFFIX: '.studio.burnsred.ai',
  BUILD_MAX_UPLOAD_BYTES: 200 * 1024 * 1024,
  IMAGE_MAX_UPLOAD_BYTES: 5 * 1024 * 1024,
  PREVIEW_IMAGES_MAX_COUNT: 10,
  BUILD_STATUS_POLL_MS: 3000,
  SCAN_STATUS_POLL_MS: 2000,
  SCAN_STATUS_POLL_MAX_MS: 10000,
  SCAN_STATUS_TIMEOUT_MS: 120000,
  MOCK_JOB_POLL_MS: 1000,
  MOCK_JOB_POLL_MAX_MS: 10000,

  MCP_SERVER_URL: 'http://localhost:8002/mcp',

  GOOGLEMAPS_API_KEY: 'TODO',
  SENTRY_DSN: import.meta.env?.VITE_SENTRY_DSN ?? '',

  FIELD_DEBOUNCE_MS: 32,
};

/** App settings with per-env overrides applied  */
export const settings = {
  ...baseSettings,
  ...environmentSettings?.[
    (import.meta.env?.MODE ?? 'test') as keyof typeof environmentSettings
  ],
};

// these variables require environmentSettings to be merged before they can be
// composed
settings.BASE_API_URL = `${settings.BASE_API_ORIGIN}/api`;
settings.AUTH_URL = `${settings.BASE_API_URL}${settings.AUTH_PATHNAME}`;
settings.SSO_URL = `${settings.AUTH_URL}sso/`;
settings.FILE_UPLOAD_URL = `${settings.BASE_API_ORIGIN}/api/br_filer/v1/file`;
settings.IMAGE_UPLOAD_URL = `${settings.BASE_API_ORIGIN}/api/br_filer/v1/image`;
settings.MOCK_API_URL = `${settings.BASE_API_ORIGIN}/api/mock`;
settings.ADMIN_URL = `${settings.BASE_API_ORIGIN}/admin/`;

export type Settings = typeof baseSettings;
